import f from 'odata-filter-builder';
import { transformODataResponse } from 'utilities/query';

import templateUrl from './category-autocomplete.html';

export default {
  templateUrl,
  bindings: {
    labelText: '@',
    searchDisplayProperty: '@',
    onItemSelected: '&'
  },
  controller: class CategoryAutocomplete {
    constructor(EventEmitter, CategoryService) {
      'ngInject';

      Object.assign(this, {
        EventEmitter,
        CategoryService
      });
    }

    searchCategories(name) {
      const query = {
        ...this.CategoryService.getDefaultQuery(),
        filter: f().and(x => x.contains('ProductCategoryName', name))
      };

      return this.CategoryService.search(query).then(r => transformODataResponse(r).Data);
    }

    selectedItemChanged(selectedItem) {
      this.onItemSelected(
        this.EventEmitter({
          selectedItem
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/autocomplete/category/category-autocomplete.component.js